import {FolderSummary} from 'constants/FolderConstants';
import * as TaskRunner from 'util/TaskRunner';

import {BulkAntibody} from './BulkAntibodyConstants';
import * as BulkAntibodyUtil from './BulkAntibodyUtil';

export function create(bulkAntibody: BulkAntibody): JQueryPromise<FolderSummary> {
  // Prepare for server
  const bulkAntibodyJSON = {
    tagSchemaId: bulkAntibody.tagSchemaId,
    folderId: bulkAntibody.outputFolderId,
    basicFolderItemSpecs: BulkAntibodyUtil.getBasicFolderItemSpecs(bulkAntibody, {forServer: true}),
  };
  return TaskRunner.runTask({
    contentType: 'application/json',
    data: JSON.stringify(bulkAntibodyJSON),
    dataType: 'json',
    type: 'POST',
    url: '/1/api/bulk-workflows/basic-folder-items/create',
  });
}
